import type { IRendererPropsExtender, IPropsStore, IStructureStore } from '@wix/thunderbolt-symbols'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { Props, StructureAPI } from '@wix/thunderbolt-symbols'
import { getDisplayedIdToCompPath } from '@wix/thunderbolt-commons'

const compPathProvider = (structureStore: IStructureStore, propsStore: IPropsStore): IRendererPropsExtender => {
	return {
		async extendRendererProps() {
			let displayedIdToCompPath: Record<string, string> | null = null
			return {
				getCompPath: (displayedId: string) => {
					if (displayedIdToCompPath === null) {
						displayedIdToCompPath = getDisplayedIdToCompPath(structureStore, propsStore)
					}
					return displayedIdToCompPath[displayedId]
				},
			}
		},
	}
}

export const CompPathProvider = withDependencies([StructureAPI, Props], compPathProvider)
